import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import { BusinessUnitModel } from '@fi-app/business-unit/business-unit.model';
import {
    DataFieldEditBusinessAreasComponent_Settings,
    TDataFieldEditBusinessAreasComponent_Settings,
} from '@fi-app/data-field/data-field-edit/business-areas/business-areas.component';
import { BehaviorSubject } from 'rxjs';
import { IAccessRightFilterCollection, ILightWeightObject } from '@fi-shared/models';
import { AccessRightService } from '@fi-shared/fi-shared-services';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { FiAccessRightHelperService } from '@fi-shared/fi-shared-services/fi-access-right-helper.service';

@Component({
    selector: 'fi-business-unit-edit-information',
    templateUrl: './fi-business-unit-edit-information.component.html',
    styleUrls: ['./fi-business-unit-edit-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-unit-edit-information' },
    providers: [
        {
            provide: DataFieldEditBusinessAreasComponent_Settings,
            deps: [FiBusinessUnitEditInformationComponent],
            useFactory: (
                instance: FiBusinessUnitEditInformationComponent,
            ): TDataFieldEditBusinessAreasComponent_Settings => {
                return {
                    accessRightFilterCollection: instance.accessRightFilterCollection,
                    dataFieldItemProperty: 'BusinessAreaIds',
                    lightWeightBusinessAreas$: instance.lightWeightBusinessAreas$,
                    isDisabledFunc: (businessArea) => instance.isBusinessAreaDisabled(businessArea),
                };
            },
        },
        { provide: FiComponentsContainer, useExisting: FiBusinessUnitEditInformationComponent },
    ],
    standalone: false,
})
export class FiBusinessUnitEditInformationComponent extends FiComponentsContainer implements OnInit {
    @Input() dataFields: DataFieldModel[];
    @Input() businessUnit: BusinessUnitModel;
    @Input() accessRightFilterCollection: IAccessRightFilterCollection;
    @Input() lightWeightBusinessAreas: ILightWeightObject[];
    lightWeightBusinessAreas$: BehaviorSubject<ILightWeightObject[]>;
    private availableBusienssAreaIds: number[];

    constructor(
        private accessRightService: AccessRightService,
        private fiAccessRightHelperService: FiAccessRightHelperService,
    ) {
        super();
    }

    ngOnInit() {
        const businessAreas = this.fiAccessRightHelperService.mergeLightWeightObjects(
            this.lightWeightBusinessAreas,
            this.businessUnit.BusinessAreas,
        );

        this.lightWeightBusinessAreas$ = new BehaviorSubject(businessAreas);
        this.availableBusienssAreaIds = this.accessRightFilterCollection.AccessRightCoreFilter.BusinessAreaIds;
    }

    isBusinessAreaDisabled(businessArea: ILightWeightObject) {
        // https://chainformation.atlassian.net/browse/FI-5481
        // don't allow deselect business areas in business unit edit screen, if user has no access to business area
        if (this.availableBusienssAreaIds.indexOf(businessArea.Id) === -1) return true;

        //https://chainformation.atlassian.net/browse/FI-5011
        // disable business area selection if there is only one business area
        if (this.availableBusienssAreaIds.length === 1) return true;

        return false;
    }
}
